// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb5edd58","389":"c8c893e8","453":"3739f826","732":"e2398eca","977":"8b3066bf"}[chunkId] + ".chunk.js";
};